import React from 'react';

import { OrderPaymentProps } from '../../types';

export const PaymarkHostedPagePayment: React.FC<OrderPaymentProps> = () => null;
